//const Version_1 =  'YAYI-V1-13B-8K' // 模型1.0版本
const Version_2 =  'YAYI-V1-30B-8K' // 模型2.0版本

export const modelVersion = Version_2;